import React from 'react';
import Container from './shared/Container';
import useScrollFade from '../hooks/useScrollFade';

const steps = [
  {
    number: "1",
    title: "Scoping",
    description: "We map your document types, decision workflows, and integration points before writing a line of config."
  },
  {
    number: "2",
    title: "Build & Integrate",
    description: "We encode your governing documents and connect to your existing systems, typically complete within two weeks."
  },
  {
    number: "3",
    title: "Expert Verification",
    description: "Your team reviews and approves every encoded rule before it handles live decisions. Nothing ships unverified."
  },
  {
    number: "4",
    title: "Launch & Improve",
    description: "We go live with full support and monitor accuracy continuously, surfacing improvement opportunities over time."
  }
];

const ImplementationProcess = () => {
  const [ref, visible] = useScrollFade();
  return (
    <section id="process" className="py-16 sm:py-24 bg-white">
      <Container>

        <div ref={ref} className={`scroll-fade${visible ? ' visible' : ''}`}>
          <div className="lg:grid lg:grid-cols-12 lg:gap-16 items-start">
            <div className="lg:col-span-4 mb-12 lg:mb-0">
              <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 tracking-tight">
                Seamless Implementation, Immediate Value
              </h2>
              <p className="mt-4 text-lg text-gray-500 leading-relaxed">
                Most clients are fully operational within 4–8 weeks, with initial value realized in as little as 2 weeks.
              </p>
            </div>

            <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-8">
              {steps.map((step) => (
                <div key={step.number} className="flex gap-4">
                  <div className="h-8 w-8 rounded-full border border-vermillion-600 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <span className="text-vermillion-600 font-semibold text-xs">{step.number}</span>
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-gray-900">{step.title}</h3>
                    <p className="mt-1.5 text-sm text-gray-500 leading-relaxed">{step.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

      </Container>
    </section>
  );
};

export default ImplementationProcess;
